import { React, Table } from '@1337lawyers/design';

export const CompletedVerificationRequests = () => (
  <Table headers={['Issuer', 'Investor', 'Requested', 'Status']} data={[]} />
);
